var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/array.js
// module id = 68
// module chunks = 0